
import { getUrl } from './connection'
import { alert } from './stores/alert'
import { getClient } from './session'
import { getLang } from './i18n'
import { loading } from './stores/loading';

let dictionary = null;

const loadLibraryDictionary = async () => {
    const clientId = getClient() || 1;
    const lang = getLang();

    if (!dictionary) {
        const [url, method] = await getUrl("dictionaryAll", { lang, clientId });
        loading.newLoading();
        try {
            const response = await fetch(url, {
                method,
                headers: {
                    'Content-Type': 'application/json; charset: utf-8'
                }
            });
            if (response.status === 200) {
                const dictResponse = await response.json();
                dictionary = {};
                dictResponse.response.forEach(({article,description}) => {
                    dictionary[article] = description;
                });
            }
            else {
                alert.newAlert({ message: translate('alerts.errors.loadLibraryDictionary'), type: 'error' });    
            }
        }
        catch (err) {
            alert.newAlert({ message: translate('alerts.errors.loadLibraryDictionary'), type: 'error' });
        }
        finally {
            loading.removeLoading();
        }
    }
}

const libTranslate = (word, fallback) => {
    if (dictionary) {
        return dictionary[word] || fallback;
    }
    else {
        console.warn("Library dictionary: translation failed because the library dictionary is not loaded");
        return fallback;
    }
}

export { loadLibraryDictionary, libTranslate }